import Header from './Header'

function TwoZeroFourEight() {
    return (
      <>
        <Header heading = "2 0 4 8"/>
      </>
    );
  }
  
  export default TwoZeroFourEight;